/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacist.reducer';

export const PharmacistDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacistEntity = useAppSelector(state => state.pharmacist.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacistDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacist.detail.title">Pharmacist</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacist.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.pharmacist.education">Education</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.pharmacist.training">Training</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.pharmacist.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.pharmacist.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.achievements}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacist.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacist.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacist.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacist.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacist.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.pharmacist.name">Name</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.pharmacist.email">Email</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.email}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.pharmacist.age">Age</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.pharmacist.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.pharmacist.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.pharmacist.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.pharmacist.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{pharmacistEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacist.tmUser">Tm User</Translate>
          </dt>
          <dd>{pharmacistEntity.tmUser ? pharmacistEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacist.contactCode">Contact Code</Translate>
          </dt>
          <dd>{pharmacistEntity.contactCode ? pharmacistEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacist.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacistEntity.pharmacy ? pharmacistEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacist" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacist/${pharmacistEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacistDetail;
